<template>
    <van-tabs v-model="active" id="recordPage">


        <van-tab title="流量订购记录">
            <div class="recordPanel">
                <div v-if="rechargeRocordList.length > 0">
                    <div v-for="item in rechargeRocordList" :key="item.id" class="records">
                        <h4>
                            <span>{{item.packageName}}</span>
                            <span class="money">{{item.priceRmb}}元</span>
                        </h4>
                        <ul class="rechargeInfo">
                            <li>
                                <label>关联单号：</label>
                                <span>{{ item.orderNo }}</span>
                            </li>
                            <li>
                                <label>生效时间：</label>
                                <span>{{ item.isNextMonthName }}</span>
                            </li>
                            <li>
                                <label>套餐类型：</label>
                                <span>{{ item.investTypeName }}</span>
                            </li>
                            <li>
                                <label>充值时间：</label>
                                <span>{{ item.createTime }}</span>
                            </li>
                        </ul>
                        <div class="btnOuter">
                            <mt-button type="primary" size="small" class="line-button line-button--mini" @click="rechargeDetail(item)">查看详情</mt-button>
                        </div>         
                    </div>
                    <div class="tips">没有更多了哦</div>
                </div>
                <div v-else class="nodata">
                    <img src="@/assets/nodata.png" alt="">
                    <span>暂无数据</span>
                </div>
            </div>
        </van-tab>


       


    </van-tabs>
</template>
<script>
import {wxRequest} from '@/api/user.js'
export default {
    data(){
        return {
            active: 2,
            balanceRechargeRocordList: [],
            rechargeRocordList: [],
            accountFlowList: [],
        }
    },
    methods: {
        rechargeDetail(item){
            this.$router.push({
                name: 'rechargeDetail',
                query: item
            })
        }
    },
    created(){
         var iccid= this.$route.query.iccid;
         if(iccid==null){
             return
         }
         console.log(iccid)
        var data = {
            iccid: iccid
        }

        wxRequest("order/pkgOrder/listPage", data, "post").then(res => {
            if(res.data.code == 200){
                this.rechargeRocordList = res.data.data.resultList;
            }
        });
    }
}
</script>
<style lang="less">
#recordPage{
    .recordPanel {
        min-height: 100%;
        background: #f2f2f2;
        .records {
            margin-bottom: 12px;
            background: #fff;
        }
        h4 {
            display: flex;
            justify-content: space-between;
            padding: 0 4%;
            line-height: 34px;
            .money {
                color: red;
            }
        }
        ul {
            padding: 0 4%;
            border-top: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            li {
                line-height: 28px;
            }
        }
        .btnOuter {
            padding: 0 4%;
            line-height: 34px;
            text-align: right;
        }
        .tips {
            color: #a0a0a0;
            text-align: center;
            line-height: 28px;
        }
        .nodata {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;  
            img {
                width: 14%;
                margin: 10px;
            }   
            span{
                margin-bottom: 10px;
            }   
        }
    }
}

</style>


